import { Absence } from './absence';
import { Holiday } from './holiday';

export class HolidayTask extends Absence {
  constructor(date: Date) {
    super('F', Holiday.absenceType, date, date);
    this.isHoliday = true;
    this.state = Holiday.state;
  }
}
